import { __decorate } from "tslib";
import { AsnProp, AsnType, AsnTypeTypes, AsnPropTypes } from "@peculiar/asn1-schema";
let ArchiveCutoff = class ArchiveCutoff {
    constructor(value = new Date()) {
        this.value = value;
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralizedTime })
], ArchiveCutoff.prototype, "value", void 0);
ArchiveCutoff = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], ArchiveCutoff);
export { ArchiveCutoff };
